import {
  OnlineSpeakingMonitoringType,
  OnlineSpeakingMonitoringResult,
  OnlineSpeakingMonitoringStatus,
} from 'api';

export const getOnlineSpeakingMonitoringTypeName = (type: OnlineSpeakingMonitoringType): string => {
  const typeNames: Record<OnlineSpeakingMonitoringType, string> = {
    [OnlineSpeakingMonitoringType.ReferenceItems]: 'Reference items',
  };
  return typeNames[type] ?? '-';
};

export const getOnlineSpeakingMonitoringResultName = (
  result: OnlineSpeakingMonitoringResult
): string => {
  const resultNames: Record<OnlineSpeakingMonitoringResult, string> = {
    [OnlineSpeakingMonitoringResult.Phase0]: 'Phase 0',
    [OnlineSpeakingMonitoringResult.Phase1]: 'Phase 1',
    [OnlineSpeakingMonitoringResult.Phase2]: 'Phase 2',
    [OnlineSpeakingMonitoringResult.Phase3]: 'Phase 3',
    [OnlineSpeakingMonitoringResult.Phase4]: 'Phase 4',
  };
  return resultNames[result] ?? '-';
};

export const getOnlineSpeakingMonitoringStatusName = (
  status: OnlineSpeakingMonitoringStatus
): string => {
  const statusNames: Record<OnlineSpeakingMonitoringStatus, string> = {
    [OnlineSpeakingMonitoringStatus.Current]: 'Current',
    [OnlineSpeakingMonitoringStatus.Archived]: 'Archived',
    [OnlineSpeakingMonitoringStatus.Deleted]: 'Deleted',
  };
  return statusNames[status] ?? '-';
};
